import { Navigate, useLocation } from 'react-router-dom';
import { resolveAdminLegacyPath } from '@lms/shared-types';

export function AdminLegacyRedirect() {
  const location = useLocation();
  const target = resolveAdminLegacyPath(location.pathname);

  if (!target) {
    return <Navigate to="/administracion" replace />;
  }

  return <Navigate to={`${target}${location.search}${location.hash}`} replace />;
}
